module.exports = __webpack_public_path__ + "static/Nexa-Bold-c9f309b3d47969ecac64a77a6c672594.otf";